import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {useLastLocation}  from 'react-router-last-location';

import {getProfile} from 'reducers/profile';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import {getLangPrefix} from 'l10n';
import paths from 'paths';

import 'sass/goBackButton.scss';

const GoBackButton = ({history, location, profile, dispatch, currentUser}) => {
    const langPrefix = getLangPrefix();
    const lastLocation = useLastLocation();
    const [prevLocation, setPrevLocation] = useState({});

    // check if we are on list items page or material page
    const isShowed = /le-mur|dressing|material|film|profil\/.*\/.*|membre\/.*/.test(location.pathname) && (/^((?!message-list).)*$/.test(location.pathname) && /^((?!pm\/).)*$/.test(location.pathname));

    // check if we are on material item page
    const itemPage = /material|film\b/.test(location.pathname);

    // check if prev page are item page
    const lastItemPage = !isEmpty(lastLocation) && /material|film\b/.test(lastLocation.pathname);

    // check if we are on materials list page
    const listPage = /le-mur|dressing|films-amateurs|album|videos-amateurs/.test(location.pathname) && !/material|film\b/.test(location.pathname) && /^((?!profil).)*$/.test(location.pathname);
    let nick;
    let goToProfile = /profil\/.*\//.test(location.pathname);

    let membre = /membre|membre\/.*/.test(location.pathname) || (lastLocation && /membre|membre\/.*/.test(lastLocation.pathname));

    // check if we open material from profile materials list
    let goToSubProfile = false;
    if (!isEmpty(lastLocation) && /profil\/.*/.test(lastLocation.pathname)) {
        goToSubProfile = true;
    }

    if (goToProfile) {
        const parts = location.pathname.split('/');
        nick = parts[parts.length - 2];
    }

    if (goToProfile && isEmpty(profile)) {
        dispatch(getProfile(nick));
    }

    // save prev location if we are on material item page
    if (itemPage && !lastItemPage && !isEqual(prevLocation, lastLocation)) {
        setPrevLocation(lastLocation);
    }

    const onClick = () => {
        if (membre) {
            history.push((langPrefix || '') + paths.member.path);
        } else if (goToSubProfile) {
            history.push(lastLocation);
        } else if (goToProfile) {
            history.push((langPrefix || '') + paths.profile.toPath({nick}));
        } else if (listPage || isEmpty(prevLocation)) {
            history.push({ pathname: langPrefix || '/' })
        } else if (!isEmpty(prevLocation)) {
            history.push(prevLocation);
        }
    };

    let profilePage = !listPage && (goToProfile || goToSubProfile);

    if (prevLocation && /profil/.test(prevLocation.pathname)) {
       profilePage = true;
    }

    const withBg = profilePage || membre;

    const classNames = ['icon-menu', 'go-back'];
    if (isShowed) classNames.push('show');
    if (withBg) classNames.push('profile');

    let bg = null;
    if (profilePage) bg = `url(${profile.avatar_url})`;
    if (membre) bg = `url(${currentUser.avatar_url})`;


    return(
        <div
            onClick={() => onClick()}
            style={{ backgroundImage: bg }}
            className={classNames.join(' ')}
        />
    )
};

GoBackButton.defaultProps = {
    profile: {},
};

GoBackButton.propTypes = {
    profile: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    profile: state.profile.user,
    currentUser: state.currentUser,
});


export default connect(mapStateToProps)(withRouter(GoBackButton));



// WEBPACK FOOTER //
// ./src/components/gobackbutton/index.js